import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import * as React from 'react';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { Module } from '../utils/Module';
import { onClickHandler, getModuleSwitcherItemURL } from '../utils/onClickHandler';
import { isFeatureEnabled } from 'owa-feature-flags';

let styles = require('./ModuleSwitcher.scss');
let classNames = require('classnames/bind').bind(styles);

export interface ModuleSwitcherItemProps extends React.HTMLAttributes<HTMLAnchorElement> {
    iconProps: IIconProps;
    workload: Module;
    selectedModule: Module;
    text: string;
    isHorizontal: boolean;
    activeModuleAction?: (
        ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>
    ) => void;
}

export default class ModuleSwitcherItem extends React.Component<ModuleSwitcherItemProps, {}> {
    render() {
        const { iconProps, workload, text, selectedModule, isHorizontal } = this.props;
        const isSelected = workload === selectedModule;
        const itemAriaProps: AriaProperties = {
            role: AriaRoles.menuitem,
            label: text,
        };

        return (
            <div className={styles.moduleSwitcherButtonContainer}>
                <CommandBarButton
                    key={workload}
                    styles={{
                        root: classNames(
                            isHorizontal ? styles.root : styles.verRoot,
                            isFeatureEnabled('fwk-fluentCommandBar') && styles.fluent
                        ),
                        menuIcon: isSelected ? styles.selectedMenuIcon : styles.menuIcon,
                    }}
                    menuIconProps={iconProps}
                    data-is-focusable={true}
                    data-workload={workload}
                    onClick={this.onClickHandler}
                    title={text}
                    href={
                        isFeatureEnabled('tri-moduleSwitcherBehavior') && !isSelected
                            ? getModuleSwitcherItemURL(workload)
                            : ''
                    } /* If module is selected, don't want to reboot whole page */
                    {...generateDomPropertiesForAria(itemAriaProps)}
                />
            </div>
        );
    }

    private onClickHandler = (ev: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>) => {
        const { workload, selectedModule, activeModuleAction } = this.props;
        onClickHandler(workload, selectedModule, activeModuleAction);
    };
}
